import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import SingleBlog from '../../components/Blog';
import DataState from '../../components/DataState';
import { useCollections } from '../../lib/api/collections';
import { newsImages } from '../../data/images';



const BlogMain = () => {
  const [params] = useSearchParams();
  const category = params.get('category');
  const content = useCollections('news');
  if (content.loading || content.error) return <DataState state={content} />;
  const news = content.news;
  const posts = (category ? news.filter((n) => n.category === category) : news).slice(0, 6);

  return (
    <main>
      <Breadcrumb title={category ? `News: ${category}` : 'Campus News'} subTitle="News" />

      <div className="it-blog-area pt-120 pb-90">
        <div className="container">
          <div className="row">
            {posts.map((post) => (
              <div key={post.id} className="col-xl-4 col-lg-4 col-md-6 mb-30">
                <SingleBlog
                  to={`/news/${post.id}`}
                  blogImage={newsImages(post).card}
                  title={post.title}
                  publishedDate={post.date}
                  category={post.category}
                  btnClass="ed-btn-blog"
                  btnText="Read More"
                  hasArrow
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};
export default BlogMain;
